import { Box, Popover } from '@mui/material';
import { useState } from 'react';
import { HexColorPicker } from 'react-colorful';
import InioTextField from '../inio-text-field/InioTextField';
import { FormikProps } from 'formik';

type Props = {
  formik: FormikProps<any>;
  name: string;
  label: string;
  placeholder?: string;
  disabled?: boolean;
};

const ColorPickerPopover = ({ formik, name, label, placeholder, disabled = false }: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (!disabled) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <Box display="flex" gap={1} data-test-id="color-picker-input">
      <InioTextField
        disabled={disabled}
        formik={formik}
        label={label}
        placeholder={placeholder || label}
        name={name}
      />

      <Box
        sx={{
          cursor: disabled ? '' : 'pointer',
          width: 54,
          height: 54,
          borderRadius: 1,
          border: '3px solid #fff',
          boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(0, 0, 0, 0.1)',
          backgroundColor: formik.values[name],
        }}
        onClick={handleClick}
      />

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box p={2}>
          <HexColorPicker
            color={formik.values[name]}
            onChange={(value) => formik.setFieldValue(name, value)}
          />
        </Box>
      </Popover>
    </Box>
  );
};

export default ColorPickerPopover;
